function ChannelType() {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc>채널 알림</desc>
      <g clipPath="url(#clip0_1011_140)">
        <path
          d="M20.5 0.5C24.4556 0.5 28.3224 1.67298 31.6114 3.87061C34.9004 6.06824 37.4638 9.19181 38.9776 12.8463C40.4913 16.5009 40.8874 20.5222 40.1157 24.4018C39.344 28.2814 37.4392 31.8451 34.6421 34.6421C31.8451 37.4392 28.2814 39.344 24.4018 40.1157C20.5222 40.8874 16.5009 40.4913 12.8463 38.9776C9.19181 37.4638 6.06824 34.9004 3.87061 31.6114C1.67298 28.3224 0.5 24.4556 0.5 20.5C0.5 15.1957 2.60714 10.1086 6.35786 6.35786C10.1086 2.60714 15.1957 0.5 20.5 0.5Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M23.7962 10.5H14.6702C14.0874 10.5079 13.5315 10.7468 13.1247 11.1641C12.7178 11.5815 12.4932 12.1432 12.5002 12.726V28.274C12.4932 28.8568 12.7178 29.4185 13.1247 29.8359C13.5315 30.2532 14.0874 30.4921 14.6702 30.5H27.2922C27.8749 30.4921 28.4308 30.2532 28.8376 29.8359C29.2445 29.4185 29.4691 28.8568 29.4622 28.274V19.483C29.4622 19.317 29.5462 16.218 29.4622 16.077L24.5502 10.936C24.4732 10.8041 24.3632 10.6945 24.231 10.618C24.0987 10.5416 23.9489 10.5009 23.7962 10.5Z"
          fill="#01A0FF"
          stroke="#01A0FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M23.7744 11.0303V16.5132H29.2173"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4976 27.0552H25.4976"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M16.4976 24.144H25.4976"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M16.4966 21.2002H25.4966"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M19.5 14.521H16.5C16.3619 14.521 16.25 14.6329 16.25 14.771V17.771C16.25 17.9091 16.3619 18.021 16.5 18.021H19.5C19.6381 18.021 19.75 17.9091 19.75 17.771V14.771C19.75 14.6329 19.6381 14.521 19.5 14.521Z"
          stroke="white"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_1011_140">
          <rect width="41" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChannelType
